<template>
  <v-card class="fill-height px-2 py-2">
    <v-alert
      border="bottom"
      class="mb-6"
      colored-border
      type="success"
      elevation="2">
      Langkah sewa
      <ol>
        <li>Pilih item yang mau disewa</li>
        <li>Klik icon WA untuk menghubungi admin</li>
        <li>Bayar via transfer atau COD</li>
        <li>Kirim bukti bayar dan foto KTP sebagai persyaratan sewa</li>
      </ol>
    </v-alert>

    <v-row>
      <v-col
        v-for="item in items"
        :key="item.title"
        :cols="colsPerRow">
        <RentalListItem :item="item" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { RentalListItem } from '../components';

export default {
  components: {
    RentalListItem,
  },

  data() {
    const details = [{
      icon: 'fas fa-house',
      label: 'Pemakaian',
      value: ['indoor & outdoor'],
    }, {
      icon: 'fas fa-list',
      label: 'Fitur',
      value: ['cabin size, ringan, bisa 3 posisi'],
    }, {
      icon: 'fas fa-dollar-sign',
      label: 'Harga sewa',
      value: ['Rp 50.000,00 / pekan', 'Rp 100.000,00 / bulan'],
    }];

    return {
      items: [
        {
          title: 'Iconic',
          category: 'Stroller',
          src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg',
          flex: 12,
          isRentOut: true,
          price: 'Rp 80.000,00/pekan',
          details,
        },
        {
          title: 'Nuna Leaf',
          category: 'Baby swing',
          src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg',
          flex: 6,
          price: 'Rp 140.000,00/bulan',
          details,
        },
        {
          title: 'Family',
          category: 'Baby walker',
          src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg',
          flex: 6,
          isRentOut: true,
          price: 'Rp 50.000,00/bulan',
          details,
        },
        {
          title: 'Lion Fisher Price',
          category: 'Baby push walker',
          src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg',
          flex: 6,
          price: 'Rp 50.000,00/bulan',
          details,
        },
        {
          title: 'Mastella',
          category: 'Booster seat',
          src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg',
          flex: 6,
          price: 'Rp 50.000,00/bulan',
          details,
        },
        {
          title: 'Parklon',
          category: 'Perosotan',
          src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg',
          flex: 6,
          price: 'Rp 100.000,00/bulan',
          details,
        },
        {
          title: 'Labielle',
          category: 'Push bike',
          src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg',
          flex: 6,
          price: 'Rp 70.000,00/bulan',
          details,
        },
        {
          title: 'Exotic',
          category: 'Trike',
          src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg',
          flex: 6,
          price: 'Rp 50.000,00/pekan',
          details,
        },
        {
          title: 'Ergo baby',
          category: 'Baby carrier',
          src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg',
          flex: 6,
          isRentOut: true,
          price: 'Rp 60.000,00/bulan',
          details,
        },
        {
          title: 'Sugarbaby',
          category: 'Playmat',
          src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg',
          flex: 6,
          price: 'Rp 40.000,00/bulan',
          details,
        },
      ],
    };
  },

  computed: {
    colsPerRow() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return this.$vuetify.breakpoint.width > 400 ? 6 : 12;
      }
      if (this.$vuetify.breakpoint.lgAndUp) return 3;
      return 4;
    },
  },
};
</script>
